<section class="container">
  <div class="d-flex p-1 mb-1 border-bottom">
    <div style="min-width: 200px;">
      <input type="text" [(ngModel)]="criteria.keyword"  />
    </div>
    <div>
      <select [(ngModel)]="criteria.isRead" >
        <option [ngValue]="undefined">همه</option>
        <option [ngValue]="false">خوانده نشده</option>
        <option [ngValue]="true">خوانده شده</option>
      </select>
    </div>
    <div>
      <select [(ngModel)]="criteria.type"  >
        <option [ngValue]="undefined">همه</option>
        <option [ngValue]="'Authentication'">Authentication</option>
        <option [ngValue]="'PaidJob'">PaidJob</option>
        <option [ngValue]="'PaidMatching'">PaidMatching</option>
        <option [ngValue]="'Matching'">Matching</option>
        <option [ngValue]="'NoMatching'">NoMatching</option>
        <option [ngValue]="'EmployerTouch'">EmployerTouch</option>
        <option [ngValue]="'SeekerTouch'">SeekerTouch</option>
        <option [ngValue]="'VerifySubscribe'">VerifySubscribe</option>
        <option [ngValue]="'Message'">Message</option>
        <option [ngValue]="'System'">System</option>
        <option [ngValue]="'Recieved'">دریافتی</option>
        <option [ngValue]="'Admin'">Admin</option>
        <option [ngValue]="'SendLink'">لینک</option>
        <option [ngValue]="'SupportMessage'">پشتیبانی</option>
        <option [ngValue]="'Agreement'">قرارداد</option>
    
      </select>
    </div>
    <div style="min-width: 200px;">
      <user-select (change)="criteria.userId=$event?.Id;"></user-select>
    </div>
    <div>
      <button class="btn btn-secondary btn-sm fs-sm" (click)="messages.load()">جستجو</button>
    </div>
    
  </div>
  <app-message #messages [showLinks]="true" [is-read]="criteria.isRead" [types]="criteria.type ? [criteria.type] : undefined" [keyword]="criteria.keyword" ></app-message>
</section>